import { request } from './axios';

// 获取代码草稿箱列表
export function gettemplatedraftlist(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/DraftList`,
    data,
  });
}
// 将草稿添加到代码模板库
export function addtotemplate(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}

// 获取代码模板列表
export function gettemplatelist(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/TemplateList`,
    data,
  });
}
// 删除指定模板
export function deletetemplate(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
